module.exports = __webpack_public_path__ + "img/hoverxcancel.f5cda232.svg";